import { NgModule } from '@angular/core';

import { SetupEndpointService } from './api/setup-endpoint.service';
import { WebQueryEndpointService } from './api/web-query-endpoint.service';
import { ImportEndpointService } from './api/import-endpoint.service';
import { SiteDepotEndpointService } from './api/site-depot-endpoint.service';
import { CustomerEndpointService } from './api/customer-endpoint.service';
import { ReportEndpointService } from './api/report-endpoint.service';
import { OffHireEndpointService } from './api/off-hire-endpoint.service';
import { ScaffoldEndpointService } from './api/scaffold-endpoint.service';
import { ApplicationForPaymentCheckListEndpointService } from './api/application-for-payment-check-list-endpoint.service';
import { ContractEndpointService } from './api/contract-endpoint.service';
import { TimesheetEndpointService } from './api/timesheet-endpoint.service';
import { TimesheetReportEndpointService } from './api/timesheet-report-endpoint.service';
import { StockReportEndpointService } from './api/stock-report-endpoint.service';
import { StaffEndpointService } from './api/staff-endpoint.service';
import { SiteEndpointService } from './api/site-endpoint.service';
import { InspectionReportEndpointService } from './api/inspection-report-endpoint.service';
import { VariationReportEndpointService } from './api/variation-report-endpoint.service';
import { ConfigurationEndpointService } from './api/configuration-endpoint.service';
import { WebCommandEndpointService } from './api/web-command-endpoint.service';
import { HandoverEndpointService } from './api/handover-endpoint.service';
import { HandoverReportEndpointService } from './api/handover-report-endpoint.service';
import { InspectionEndpointService } from './api/inspection-endpoint.service';
import { AssetsEndpointService } from './api/assets-endpoint.service';
import { ExportEndpointService } from './api/export-endpoint.service';
import { VariationEndpointService } from './api/variation-endpoint.service';
import { ScaffoldReportEndpointService } from './api/scaffold-report-endpoint.service';
import { SiteDepotCommandService } from './command/site-depot-command.service';
import { TimesheetCommandService } from './command/timesheet-command.service';
import { StaffCommandService } from './command/staff-command.service';
import { ScaffoldCommandService } from './command/scaffold-command.service';
import { OffHireCommandService } from './command/off-hire-command.service';
import { HandoverCommandService } from './command/handover-command.service';
import { DismantleCommandService } from './command/dismantle-command.service';
import { VariationCommandService } from './command/variation-command.service';
import { SiteCommandService } from './command/site-command.service';
import { CustomerCommandService } from './command/customer-command.service';
import { ContractCommandService } from './command/contract-command.service';
import { ConfigurationCommandService } from './command/configuration-command.service';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Module containing code generated from Hub API.
@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [
    SetupEndpointService,
    WebQueryEndpointService,
    ImportEndpointService,
    CustomerEndpointService,
    ReportEndpointService,
    OffHireEndpointService,
    ScaffoldEndpointService,
    ApplicationForPaymentCheckListEndpointService,
    ContractEndpointService,
    TimesheetEndpointService,
    TimesheetReportEndpointService,
    StockReportEndpointService,
    StaffEndpointService,
    SiteEndpointService,
    SiteDepotEndpointService,
    InspectionReportEndpointService,
    VariationReportEndpointService,
    ConfigurationEndpointService,
    WebCommandEndpointService,
    HandoverEndpointService,
    HandoverReportEndpointService,
    InspectionEndpointService,
    AssetsEndpointService,
    ExportEndpointService,
    VariationEndpointService,
    ScaffoldReportEndpointService,
    SiteDepotCommandService,
    TimesheetCommandService,
    StaffCommandService,
    ScaffoldCommandService,
    OffHireCommandService,
    HandoverCommandService,
    DismantleCommandService,
    VariationCommandService,
    SiteCommandService,
    CustomerCommandService,
    ContractCommandService,
    ConfigurationCommandService,
  ]
})
export class HubApiGeneratedModule { }
